import { render } from "./CreateFtl.vue?vue&type=template&id=3d07138e&scoped=true&ts=true"
import script from "./CreateFtl.vue?vue&type=script&lang=ts"
export * from "./CreateFtl.vue?vue&type=script&lang=ts"

import "./CreateFtl.vue?vue&type=style&index=0&id=3d07138e&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d07138e"]])

export default __exports__